export enum FundraisingTypes {
  matching = 'matching',
  standard = 'standard',
  event = 'event',
}
